import HowDidYouHearAboutUs from "@/pages/registerCompany/steps/interestSelection/HowDidYouHearAboutUs";
import InstagramField from "@/pages/registerCompany/steps/interestSelection/InstagramField";
import InterestSelection from "@/pages/registerCompany/steps/interestSelection/InterestSelection";
import TikTokField from "@/pages/registerCompany/steps/interestSelection/TikTokField";
import {type FC} from "react";

const InterestSelectionStep: FC = () => {
  return (
    <div className="flex w-full flex-col gap-5">
      <InstagramField />
      <TikTokField />
      <InterestSelection />
      <HowDidYouHearAboutUs />
    </div>
  );
};

export default InterestSelectionStep;
